


import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default () => {
  gsap.registerPlugin(ScrollTrigger);

  // //--------------------------------//
  // // Menu slide animation
  // //--------------------------------//
  // // Menu slide animation
  // const navigationSlide = document.querySelector("#navigation-slide");
  // const q = gsap.utils.selector(navigationSlide);
  // const menuSlideAnimation = gsap.timeline({
  //   paused: true,
  //   reversed: true,
  //   defaults: { duration: 0.2, ease: "power4.in" }
  // });
  // gsap.set(navigationSlide, { xPercent: 100 });
  // // Animation
  // menuSlideAnimation.set(navigationSlide, { autoAlpha: 1 });
  // menuSlideAnimation.to(navigationSlide, { xPercent: 0, duration: 0.2 });
  // menuSlideAnimation.from(q("ul li"), {
  //   x: 100,
  //   opacity: 0,
  //   stagger: { amount: 0.3 }
  // });
  // menuSlideAnimation.from(q(".extra > *"), {
  //   opacity: 0,
  //   stagger: { amount: 0.3 }
  // });
  // // Menu toggle setup
  // let tlMenuToggleAll = []; // Collect all menu buttons;
  // const menuToggle = document.querySelectorAll(".menu-toggle");
  // // Animation function
  // function menuToggleAnimation(target) {
  //   const q = gsap.utils.selector(target);
  //   // Menu toggle animation
  //   const tl = gsap.timeline({
  //     paused: true,
  //     reversed: true,
  //     defaults: { duration: 0.3, ease: "power3.in" }
  //   });
  //   tl.to(q(".anim"), { y: 0 });
  //   tl.to(q(".anim"), {
  //     duration: 0.45,
  //     rotate: gsap.utils.wrap([45 * 3, 45 * 5])
  //   });
  //   tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");
  //   tlMenuToggleAll.push(tl); // Capture all timelines
  //   return tl;
  // }
  // // 👆 Click logic function 
  // function menuToggleClick(target) {
  //   // Setup aria roles
  //   target.setAttribute('aria-haspopup', 'true');
  //   target.setAttribute('aria-expanded', 'false');
  //   target.setAttribute('aria-controls', 'navigation-slide');


  //   // Click logic 
  //   target.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     document.body.classList.toggle("showNavigationSlide");
  //     menuSlideAnimation.reversed()
  //       ? menuSlideAnimation.play()
  //       : menuSlideAnimation.reverse();
  //     tlMenuToggleAll.forEach((timeline, index) => {
  //       timeline.reversed() ? timeline.play() : timeline.reverse();
  //       // ♿️ Accessibility logic
  //       menuToggle[index].setAttribute(
  //         "aria-expanded",
  //         menuToggle[index].getAttribute("aria-expanded") == "false"
  //           ? "true"
  //           : "false"
  //       );
  //     });
  //   });
  // }
  // document.querySelectorAll(".menu-toggle").forEach((item) => {
  //   const q = gsap.utils.selector(item);
  //   const offset = item.getBoundingClientRect().height * 0.2;
  //   // Ready function
  //   function ready() {
  //     // Add animation to button
  //     if (item.tagName === "BUTTON") {
  //       menuToggleAnimation(item);
  //     }
  //     // 👆 Add click logic
  //     menuToggleClick(item);
  //   }
  //   // Page load animation
  //   const tl = gsap.timeline({
  //     onComplete: () => ready()
  //   });
  //   // Animate only if item is a button
  //   if (item.tagName === "BUTTON") {
  //     tl.to(q(".anim"), {
  //       y: gsap.utils.wrap([offset, -offset]),
  //       duration: 0.15,
  //       ease: "power4.in"
  //     });
  //     tl.from(q(".text"), { opacity: 0 });
  //   }
  // });
  // // END Menu slide animation --------------//
  //--------------------------------//
  // Menu toggle animation
  //--------------------------------//
  // Menu toggle setup
  let tlMenuToggleAll = [];  // Collect all menu buttons;
  const menuToggle = document.querySelectorAll('.menu-toggle');
  // Animation function
  function menuToggleAnimation(target) {
    const q = gsap.utils.selector(target);
    // Menu toggle animation
    const tl = gsap.timeline({
      paused: true,
      reversed: true,
      defaults: { duration: 0.3, ease: 'power3.in' },
      onComplete: () => target.setAttribute('aria-expanded', true),
      onReverseComplete: () => target.setAttribute('aria-expanded', false),
    });
    // // ---- Simple ----
    // tl.to(q(".anim"), {rotate: gsap.utils.wrap([-45, 45])});
    // tl.to(q(".anim"), { y: 0 }, "<");
    // tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");

    //   // ---- Spinning ----
    //   tl.to(q(".inner"), { duration: 0.8, rotate: 360 * 3 });
    //   tl.to(q(".anim"), { y: 0 }, "<");
    //   tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");
    //   tl.to(q(".anim"), {
    //     duration: 0.45,
    //     rotate: gsap.utils.wrap([45 * 3, 45 * 5])
    //   }, "-=0.6");

    // // ---- Rotate ----
    // tl.to(q(".inner"), { rotate: -90 });
    // tl.to(q(".anim"), { y: 0 }, "<");
    // tl.to(q(".anim"), {rotate: gsap.utils.wrap([45, -45])});
    // tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");

    // // ---- Move out in ----
    // tl.to(q(".inner span"), { xPercent: -150, stagger: 0.1 });
    //   tl.set(q(".anim"), { y: 0 });
    // tl.set(q(".anim"), {
    //   duration: 0.45,
    //   rotate: gsap.utils.wrap([45 * 3, 45 * 5])
    // });
    // tl.set(q(".text"), { opacity: 0 }, "<");
    // tl.set(q(".inner span"), { xPercent: 0 });
    // tl.set(q(".inner .anim"), { xPercent: 150 });
    // tl.to(q(".inner .anim"), { xPercent: 0 });

    // ---- Rotate animation ----
    tl.to(q('.anim'), { y: 0 });
    tl.to(q('.anim'), {
      duration: 0.45,
      rotate: gsap.utils.wrap([45 * 3, 45 * 5]),
    });
    tl.to(q('.text'), { duration: 0.1, opacity: 0 }, '<');
    tlMenuToggleAll.push(tl);  // Capture all timelines
    return tl;
  }

  function toggleAnimation(dialogId) {
    if (dialogId === 'navigation-slide') {
      tlMenuToggleAll.forEach((tl) => {
        tl.reversed() ? tl.play() : tl.reverse();
      });
    }
  }

  document.querySelectorAll('.menu-toggle').forEach((item) => {
    const q = gsap.utils.selector(item);
    const offset = item.getBoundingClientRect().height * 0.2;
    // Animate only if item is a button
    if (item.tagName === 'BUTTON') {
      gsap.set(q('.anim'), {
        y: gsap.utils.wrap([offset, -offset]),
        duration: 0.15,
        ease: 'power4.in',
      });
      gsap.set(q('.text'), { opacity: 1 });
      // Create animation
      menuToggleAnimation(item);
    }
  });
  // END Menu slide animation --------------//
  // END Menu toggle animation --------------//

  //--------------------------------//
  // Dialog logic
  //--------------------------------//
  document.querySelectorAll('.dialog-open').forEach(button => {
    button.addEventListener('click', (event) => {
      const dialogId = button.getAttribute('aria-controls');
      const dialog = document.getElementById(dialogId);

      if (dialog) {
        document.querySelector('#live-region').textContent =
          dialog.dataset.liveOpen;
        dialog.showModal();
        dialog.setAttribute('aria-expanded', true);
        toggleAnimation(dialogId);
      }
    });
  });

  document.querySelectorAll('.dialog-close').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('dialog[open]').forEach(dialog => {
        document.querySelector('#live-region').textContent =
          dialog.dataset.liveClose;
        dialog.close();
        dialog.setAttribute('aria-expanded', false);
        toggleAnimation(dialog.id);
      });
    });
  });

  // Close dialog when clicking outside of its content
  document.addEventListener('click', (event) => {
    const openDialogs = document.querySelectorAll('dialog[open]');

    openDialogs.forEach(dialog => {
      if (event.target === dialog) {
        dialog.close();
        dialog.setAttribute('aria-expanded', false);
        toggleAnimation(dialog.id);
      }
    });
  });
  // END Dialog elements --------------//

  //------------------------------------------------------//
  // On browser 📜 scroll full window height  
  //------------------------------------------------------//
  ScrollTrigger.create({
    id: "Scrolled",
    trigger: "body",
    start: `${window.innerHeight * 1.5} bottom`,
    toggleClass: "showScrolled"
  });
  // END On browser 📜 scroll full window height  -------------------------------------//

  //------------------------------------------------------//
  // Tab/Toggle functionality for vacatures
  //------------------------------------------------------//
  const toggleContainers = document.querySelectorAll('.toggle-container');

  toggleContainers.forEach(container => {
    const tabs = container.querySelectorAll('.toggle-tab');
    const tabPanels = container.querySelectorAll('.toggle-item');

    if (tabs.length === 0) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = tab.getAttribute('data-tab-target');
        const targetPanel = container.querySelector(`.toggle-item.${targetId}`);

        if (!targetPanel) return;

        // Remove active state from all tabs and panels
        tabs.forEach(t => {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });

        tabPanels.forEach(panel => {
          panel.classList.remove('active');
          panel.setAttribute('hidden', '');
        });

        // Add active state to clicked tab and corresponding panel
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        targetPanel.classList.add('active');
        targetPanel.removeAttribute('hidden');
      });

      // Keyboard navigation support
      tab.addEventListener('keydown', (e) => {
        const currentIndex = Array.from(tabs).indexOf(tab);
        let targetIndex = null;

        switch (e.key) {
          case 'ArrowLeft':
            e.preventDefault();
            targetIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
            break;
          case 'ArrowRight':
            e.preventDefault();
            targetIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
            break;
          case 'Home':
            e.preventDefault();
            targetIndex = 0;
            break;
          case 'End':
            e.preventDefault();
            targetIndex = tabs.length - 1;
            break;
        }

        if (targetIndex !== null) {
          tabs[targetIndex].focus();
          tabs[targetIndex].click();
        }
      });
    });
  });
  // END Tab/Toggle functionality --------------//
}